// This file is generated by scripts/generate.mjs — do not edit.
// Source: svg/arrow-up.svg
import { IconBase } from "./icon-base";
import type { IconProps } from "./types";

export function ArrowUpIcon(props: IconProps) {
	return (
		<IconBase viewBox="0 0 16 16" {...props}>
			<path
				d="M8.00098 1.37549C8.32663 1.37562 8.63984 1.50459 8.87012 1.73486L14.4434 7.30811C14.687 7.55217 14.6872 7.9489 14.4434 8.19287C14.1994 8.43683 13.8027 8.43658 13.5586 8.19287L9.99166 4.62594C9.56329 4.19756 9.3491 3.98337 9.16521 3.9689C9.00565 3.95634 8.84972 4.02093 8.74577 4.14264C8.62598 4.2829 8.62598 4.58581 8.62598 5.19162V14.0005C8.62571 14.3453 8.34577 14.6252 8.00098 14.6255C7.65596 14.6255 7.37624 14.3454 7.37598 14.0005V5.19162C7.37598 4.58581 7.37598 4.2829 7.25618 4.14264C7.15223 4.02093 6.99631 3.95634 6.83675 3.9689C6.65286 3.98337 6.43867 4.19756 6.01029 4.62594L2.44336 8.19287C2.1994 8.43683 1.8027 8.43658 1.55859 8.19287C1.31452 7.94879 1.31452 7.55218 1.55859 7.30811L7.13184 1.73486C7.36222 1.50455 7.67521 1.37549 8.00098 1.37549Z"
				fill="currentColor"
			/>
		</IconBase>
	);
}
